import { render, staticRenderFns } from "./SecondForm.vue?vue&type=template&id=2ffedd0e&"
import script from "./SecondForm.vue?vue&type=script&lang=js&"
export * from "./SecondForm.vue?vue&type=script&lang=js&"
import style0 from "./SecondForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports